<template>
 <detail :screen="screen" :w="w" :y="y" :id="id" :url="url" :button-title="y == 'isYY'?'立即预约':'立即购买'" :isoff="true"></detail>
</template>

<script type="text/javascript">

import Detail from '@/components/Detail'

export default {
    components: {
        Detail
    },
    props: {
        screen:{
            type: Object,
            default: () => {}
        },
        id: {
            type: String
        },
        w: {
            type: String
        },
        y:{
          type: String
        }
    },
    data() {
        return {
            title:'立即购买',
            url: {
                get: SZH.assets.api + "/Order/GetProductInfo",
                canBuy: SZH.assets.api + '/Order/GetCanBuyProduct'
            },
        }
    },
    methods: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        sessionStorage.setItem("product-type", "other");
        sessionStorage.removeItem("OrderKey");
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Detail/Detail2.vue